export default __webpack_public_path__ + "static/media/2526 knife block A side.88065769.png";